import styled from 'styled-components';
import { Themes } from '../../style/theme-consts';
import { Linked } from '../Buttons/Button/index';
import { B1, H2, TypographyWeight } from '../../style/Typography/index';
import '../../style/Colors/color-variables.css';

const variantToColor = {
  success: 'var(--snackbar-success-bg)',
  error: 'var(--snackbar-error-bg)',
  warning: 'var(--snackbar-warning-bg)'
};

export const SnackbarCard = styled.div.attrs({ className: Themes.LIGHT })`
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  padding: 0;
  border-radius: 8px;
  background: var(--snackbar-card-bg);
  box-shadow: 0 1px 8px var(--snackbar-card-shadow);
  min-width: 440px;
  width: auto;
  height: 108px;
  display: flex;
  align-items: center;
  position: relative; /* for absolute close button */

  /* LEFT STRIP (variant-based, flat edges inside, rounded outside) */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    border-radius: 8px 0 0 8px;
    background-color: ${({ $color, $variant }) => $color || variantToColor[$variant] || 'var(--snackbar-info-bg)'};
  }
`;

export const SnackbarInner = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  gap: 16px;
  padding: 0 30px;

  .variant-icon {
    align-self: center;
  }
`;

/* TEXT AREA */
export const SnackbarText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0; /* allows ellipsis inside flex item */
  height: 100%;
  justify-content: center;
`;

export const SnackbarTitle = styled(H2).attrs({ weight: TypographyWeight.SEMI_BOLD })`
  color: var(--snackbar-title-color);
`;

/* MESSAGE WITH 2-LINE ELLIPSIS */
export const SnackbarMessage = styled(B1)`
  color: var(--snackbar-message-color);
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* max 2 line */
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const SnackbarLink = styled(Linked)`
  padding: 0;
  height: 24px;
  width: fit-content;
`;

export const SnackbarClose = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  transition: background 0.2s ease;

  svg {
    width: 12px;
    height: 12px;
    display: block;
  }

  &:hover {
    background: var(--black-50);
  }

  &:active {
    background: var(--black-100);
  }
`;
